import axios from "axios";

// Tanda tangan digital karyawan — API langsung (terpisah dari slice enrollment wajah).
const API_URL = process.env.REACT_APP_API_URL;

const headers = () => {
  let token = "";
  try {
    token = JSON.parse(localStorage.getItem("user") || "null")?.Token ?? "";
  } catch {
    token = "";
  }
  return { Authorization: "Bearer " + token, Accept: "*/*" };
};

const pesan = (e, fallback) => e?.response?.data?.message || e?.message || fallback;

export const simpanTandaTangan = async (nik, blob, metode) => {
  const f = new FormData();
  f.append("Nik", nik);
  f.append("Metode", metode);
  f.append("File", blob, "tandatangan.png");
  try {
    await axios.post(API_URL + "hrd/InsertTandaTangan", f, { headers: headers() });
  } catch (e) {
    throw new Error(pesan(e, "Gagal menyimpan tanda tangan"));
  }
};

// Gambar diminta dengan header Authorization → ambil sebagai blob, tampilkan lewat object URL.
export const ambilGambarTandaTangan = async (nik) => {
  try {
    const r = await axios.get(API_URL + "hrd/TandaTanganImage", {
      headers: headers(),
      params: { nik },
      responseType: "blob",
    });
    return URL.createObjectURL(r.data);
  } catch (e) {
    return null;
  }
};

export const hapusTandaTangan = async (nik) => {
  const f = new FormData();
  f.append("Nik", nik);
  try {
    await axios.post(API_URL + "hrd/DeleteTandaTangan", f, { headers: headers() });
  } catch (e) {
    throw new Error(pesan(e, "Gagal menghapus tanda tangan"));
  }
};
